<div class="e-grid-wrap" [class.hidden]="isLoading() || exportModalOpen">
<ag-grid-angular id="e-detailed-editing-grid"
                   class="ag-theme-alpine"
                   rowSelection="multiple"
                   [rowData]="rowData"
                   [headerHeight]="gridProperties.headerHeight"
                   [rowHeight]="gridProperties.rowHeight"
                   [columnDefs]="colDefs"
                   (gridReady)="onGridReady($event)"
                   [gridOptions]="gridOptions"
                   (selectionChanged)="onSelectionChanged($event)"
                   ></ag-grid-angular>
</div>

@if (isLoading()) {
    <div class="e-loading">
      <span class="fas fa-spinner-third fa-spin"></span>
      <p>Loading Claims Data</p>
    </div>
}

<div>
  <claims-generic-loader [genericLoaderDetail]="genericLoaderData"></claims-generic-loader>
</div>


@if (exportModalOpen) {
  <div class="export-modal-backdrop" tabindex="-1" aria-hidden="false">
    <div id="export-modal"
         class="export-modal"
         role="dialog"
         aria-modal="true"
         aria-labelledby="exportModalTitle"
         tabindex="0"
         (keydown)="onModalKeydown($event)">
      <h2 id="exportModalTitle">Export Options</h2>
      <button (click)="closeExportModal()" tabindex="0">Close</button>
    </div>
  </div>
}